import React, {useEffect} from "react";
import {routeNames} from "../../Navigation/routeNames";
import {NavigationItem} from "../../../store/navigation/actions/NavigationActionTypes";
import {setNavigationItems} from "../../../store/navigation/actions/NavigationActions";
import {useDispatch} from "react-redux";
import UploadFileFormContainer from "./Components/UploadFileFormContainer";
import TopBar from "../Layouts/Layout/Components/TopBar/TopBar";
import XDriveBreadcrumb from "../../Breadcrumbs/XDriveBreadcrumb";
import TopBarElementTitle from "../Layouts/Layout/Components/TopBar/TopBarElementTitle";
import TopBarTabs from "../Layouts/Layout/Components/TopBar/TopBarTabs";
import UploadManager from "../../UploadManager/UploadManager";

function LeftTopBarElements() {
    return (
        <div className="breadcrumb-bar">
            <TopBarTabs />
        </div>
    );
}

const UploadFile = () => {
    const dispatch = useDispatch();

    /** Page Setup */
    useEffect(() => {
        const navItems: NavigationItem[] = [
            {
                name: routeNames.xDrive.name,
                path: routeNames.xDrive.path
            }
        ];

        //Set Nav Items
        dispatch(setNavigationItems(navItems));
    }, []);
    return (
        <React.Fragment>
            <TopBar
                titleText="Upload File"
                leftElem={<TopBarElementTitle title="X-Drive" element={<LeftTopBarElements />} />}
                rightElem={<UploadManager />}
            />
            <div className="page-container mt-4">
                <XDriveBreadcrumb />
                <UploadFileFormContainer />
            </div>
        </React.Fragment>
    );
};

export default UploadFile;
